const DECIMAL_FRAME_RATE_PATTERN = /^(?:\d+(?:\.\d+)?|\.\d+)$/
const RATIONAL_FRAME_RATE_PATTERN = /^(\d+)\s*\/\s*(\d+)$/

export const normalizeDecimalFrameRate = (value: string): string | null => {
  const trimmed = value.trim()
  if (!DECIMAL_FRAME_RATE_PATTERN.test(trimmed)) {
    return null
  }

  const parsed = Number(trimmed)
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return null
  }

  const [rawInteger = '', rawFraction = ''] = trimmed.split('.')
  const integer = (rawInteger || '0').replace(/^0+(?=\d)/, '')
  const fraction = rawFraction.replace(/0+$/, '')

  return fraction ? `${integer}.${fraction}` : integer
}

// Astra 探测结果可能使用有理数表示；只在这条外部数据入口转换，持久化值和业务读侧均只接受十进制字符串。
export const decimalFrameRateFromReportedValue = (value: string): string | null => {
  const decimal = normalizeDecimalFrameRate(value)
  if (decimal !== null) return decimal

  const match = value
    .trim()
    .match(RATIONAL_FRAME_RATE_PATTERN)
  if (!match) return null

  const numerator = Number(match[1])
  const denominator = Number(match[2])
  if (!Number.isFinite(numerator) || !Number.isFinite(denominator) || numerator <= 0 || denominator <= 0) {
    return null
  }

  return normalizeDecimalFrameRate(String(Math.round((numerator / denominator) * 1000) / 1000))
}
